import React from 'react'
import { Link } from 'react-router-dom'
import MenuGuideButton from '../components/MenuGuideButton'
import SalesImagesGeminiLibrary from './SalesImagesGeminiLibrary'

export default function SalesImagesListPage() {
    return (
        <div className="space-y-5">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                <div>
                    <div className="flex flex-wrap items-center gap-2">
                        <h1 className="text-2xl font-bold">이미지 자료실</h1>
                        <MenuGuideButton slug="sales-images" title="이미지 자료실 가이드" />
                    </div>
                </div>
                <Link
                    className="text-sm text-slate-600 hover:text-brand-navy underline underline-offset-2 shrink-0"
                    to="/sales-images/org-templates"
                >
                    조직별 업로드 템플릿
                </Link>
            </div>
            <SalesImagesGeminiLibrary />
        </div>
    )
}
